import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const titleRef = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    el.style.opacity = '0';
    el.style.transform = 'translateY(30px)';
    setTimeout(() => {
      el.style.transition = 'opacity 0.9s ease, transform 0.9s ease';
      el.style.opacity = '1';
      el.style.transform = 'translateY(0)';
    }, 100);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/1b8ac6e01e4ec8b56d24bb0f3ec90c38.jpg"
          alt="3D Printing in action"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6 md:px-10 flex flex-col items-center">
        <span className="inline-block border border-white/40 text-white text-xs uppercase tracking-[2px] px-5 py-2 rounded-full mb-8 backdrop-blur-sm bg-white/10">
          Custom 3D Printing Services
        </span>

        <h1 ref={titleRef} className="text-5xl md:text-7xl font-black text-white leading-tight mb-6 max-w-4xl">
          <span className="bg-gradient-to-r from-fuchsia-400 via-orange-300 to-cyan-400 bg-clip-text text-transparent">
            Reader Brothers
          </span>
          <br />
          <span className="text-white">Printing</span>
        </h1>

        <p className="text-xl md:text-2xl text-white/80 italic font-light mb-4 max-w-2xl">
          "If you can think it, we can build it."
        </p>
        <p className="text-base md:text-lg text-white/60 max-w-xl mb-10 leading-relaxed">
          From prototypes to custom art pieces — we bring your boldest ideas to life with precision and passion.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 items-center">
          <Link
            to="/contact"
            className="whitespace-nowrap px-8 py-4 rounded-full font-bold text-white text-base bg-gradient-to-r from-fuchsia-500 via-orange-400 to-cyan-400 hover:opacity-90 transition-all duration-200 hover:scale-105"
          >
            Start Your Project
          </Link>
          <Link
            to="/about"
            className="whitespace-nowrap px-8 py-4 rounded-full font-bold text-white text-base border-2 border-white/40 hover:border-white/80 backdrop-blur-sm bg-white/10 transition-all duration-200"
          >
            Meet the Brothers
          </Link>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/50 text-xs uppercase tracking-widest">Scroll</span>
          <i className="ri-arrow-down-line text-white/50 text-xl"></i>
        </div>
      </div>
    </section>
  );
}
